// main naming
export const LIVE_MUSIC             = 'liveMusic';
export const SERVICE                = 'service';
export const BAND                   = 'band';
export const MUSICIAN               = 'musician';

// global sizes
export const MOBILE_SIZE            = 821;
export const MOBILE_SMALL_WIDTH     = 350;
export const MOBILE_SMALL_HEIGHT    = 650;

// mobile modes
export const MOBILE_MODE_GALLERY    = 'gallery';
export const MOBILE_MODE_MAP        = 'map';

// Huge and high pins size factor
export const MAP_MARKER_HIGH_PAID_SIZE = 15;

export const MUGICS_LIST = [LIVE_MUSIC, SERVICE, BAND, MUSICIAN]

// style consts
// let vh = window && window.innerHeight * 0.01;
// document.documentElement.style.setProperty('--vh', `${vh}px`);



// WEBPACK FOOTER //
// ./src/consts.js